export interface ErrorResponse {
  message: string;
  details?: string;
  statusCode: number;
  timestamp: Date;
}

export class SavaquanHttpError extends Error {
  public readonly message: string;
  public readonly details?: string;
  public readonly statusCode: number;
  public readonly timestamp: Date;

  constructor(errorResponse: ErrorResponse) {
    super(errorResponse.message);
    this.name = 'SavaquanHttpError';
    this.message = errorResponse.message;
    this.details = errorResponse.details;
    this.statusCode = errorResponse.statusCode;
    this.timestamp = errorResponse.timestamp;
    
    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, SavaquanHttpError);
    }
  }
}
